export const isEmpty = <T extends {}>(array?: T[]) => array ? array.length === 0 : true

export const hasAny = <T extends {}>(array?: T[]) => !isEmpty(array)

export const range = (start: number, end: number) => Array.from({ length: (end - start + 1) }, (_, k) => k + start)

export const int = (num: any) => parseInt(num, 10) || 0

export type Omit<T, K> = Pick<T, Exclude<keyof T, K>>

export type Subtract<T, K> = Omit<T, keyof K>

export const truthy = <T>(x?: T | false): x is T => Boolean(x)

export const tuple = <T extends string>(args: T[]) => args

export const flattenArray = <T extends {} | undefined>(arraytoFlatten: T[][]): T[] =>
  arraytoFlatten.reduce((result: T[], array: T[]) => result.concat(array), [] as T[])

export const flatten = (arr: any[]): any[] =>
  (arr.reduce((flat, toFlatten) => (Array.isArray(toFlatten) ? flat.concat(flatten(toFlatten)) : flat.concat(toFlatten)), []))

export const safeBoolean = (thing: '1' | '0' | 0 | 1 | true | false | undefined | null) => thing == true

export const stringifyOnClient = (args?: object | undefined) => (
  global.__SERVER__ === true ? args : args && JSON.stringify(args)
)

export type AcknowledgeEvent = { nativeEvent: { ack?: Function } }
export type ExtendedMouseEvent = React.MouseEvent<HTMLElement> & AcknowledgeEvent
export const acknowledgeEvent = (e: React.MouseEvent<HTMLElement>) => {
  if (e && (e as ExtendedMouseEvent).nativeEvent && (e as ExtendedMouseEvent).nativeEvent.ack) {
    (e as ExtendedMouseEvent).nativeEvent.ack!(e.currentTarget)
  }
}

export const numericalSorter = (a: number, b: number) => a - b

export const COUNTER_PACKAGE_PREFIX = 'DVWebNodeDetail'

export const popupWindowParams = (width: number, height: number) => {
  const popupWidth = width ? width : window.innerWidth * 0.7
  const popupHeight = height ? height : window.innerHeight * 0.7
  // Opens the new window at the center of the current window.
  const top = (window.top.outerHeight / 2) + window.top.screenY - (popupHeight / 2)
  const left = (window.top.outerWidth/ 2) + window.top.screenX - (popupWidth / 2)
  return `toolbar=0, status=0, width=${popupWidth}, height=${popupHeight}, top=${top}, left=${left}`
}